module.exports = __webpack_public_path__ + "img/SUPPRIMER.8d13fb28.svg";